import { getPeopleByComunity } from './results/peopleByComunity';
import { getPeopleByCountry } from './results/peopleByCountry';
import { getPeopleByMunicipalities } from './results/peopleByMunicipalities';
import { getPeopleByProvince } from './results/peopleByProvince';
import { toast } from 'react-toastify';

export const uploadExcellDataSet = data => {
    let countryData = [], municipalityData = [], provinceData = [], stateData = [];
    for (let i = 0; i < data.length; i++) {
        if (data[i].key === 'country') {
            let total = 0;
            for (let j = 0; j < data[i].data.length; j++) {
                total += parseInt(data[i].data[j].personas, 10);
            }
            countryData = [...data[i].data];
            countryData.push({ country_name: "Total", personas: total });
        }
        if (data[i].key === 'province') {
            let total = 0;
            for (let j = 0; j < data[i].data.length; j++) {
                total += parseInt(data[i].data[j].personas, 10);
            }
            provinceData = [...data[i].data];
            provinceData.push({ province_name: "Total", personas: total });
        }
        if (data[i].key === 'state') {
            let total = 0;
            for (let j = 0; j < data[i].data.length; j++) {
                total += parseInt(data[i].data[j].personas, 10);
            }
            stateData = [...data[i].data];
            stateData.push({ state_name: "Total", personas: total });
        }
        if (data[i].key === 'municipality') {
            let total = 0;
            for (let j = 0; j < data[i].data.length; j++) {
                total += parseInt(data[i].data[j].personas, 10);
            }
            municipalityData = [...data[i].data];
            municipalityData.push({ municipality_name: "Total", personas: total });
        }
    }
    let excellData = [
        {
            columns: [{
                label: "País",
                value: "country_name"
            }, {
                label: "Visitantes",
                value: "personas"
            }],
            data: countryData ? countryData : [],
            key: "country_data"
        }, {
            columns: [{
                label: "Comunidade",
                value: "state_name"
            }, {
                label: "Visitantes",
                value: "personas"
            }],
            data: stateData ? stateData : [],
            key: "state_data"
        }, {
            columns: [{
                label: "Provincia",
                value: "province_name"
            }, {
                label: "Visitantes",
                value: "personas"
            }],
            data: provinceData ? provinceData : [],
            key: "province_data"
        }, {
            columns: [{
                label: "Localidade",
                value: "municipality_name"
            }, {
                label: "Visitantes",
                value: "personas"
            }],
            data: municipalityData ? municipalityData : [],
            key: "municipality_data"
        }
    ];
    return excellData;
}


export const loadData = async (data, sessionData, filter) => {
    try {
        let responseCountry = await getPeopleByCountry(sessionData.userName, sessionData.passwd, filter);
        let responseComunity = await getPeopleByComunity(sessionData.userName, sessionData.passwd, filter);
        let responseMunicipality = await getPeopleByMunicipalities(sessionData.userName, sessionData.passwd, filter);
        let responseProvince = await getPeopleByProvince(sessionData.userName, sessionData.passwd, filter);
        data.forEach((item) => {
            if (item.key === 'country') {
                item.data = responseCountry.result.data;
                item.total = responseCountry.result.total;
            }
            if (item.key === 'state') {
                item.data = responseComunity.result.data;
                item.total = responseComunity.result.total;
            }
            if (item.key === 'province') {
                item.data = responseProvince.result.data;
                item.total = responseProvince.result.total;
            }
            if (item.key === 'municipality') {
                item.data = responseMunicipality.result.data;
                item.total = responseMunicipality.result.total;
            }
        });
        let excellData = uploadExcellDataSet(data);
        return { data: data, excellData: excellData };
    } catch (err) {
        console.error(err);
        toast("Produciuse un erro ao obter os datos. Intenteo de novo máis tarde", { className: "toast-error", autoClose: 3500 });
    }
}



// WEBPACK FOOTER //
// ./src/controllers/Dashboard.js